import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import { dashable, nullable } from "@/plugins/custom-filters";
import i18n from "@/plugins/i18n";
import * as Sentry from "@sentry/vue";
import JsonViewer from 'vue-json-viewer'
Vue.config.productionTip = false;
Vue.use(JsonViewer)
Sentry.init({
  Vue,
  dsn: process.env.VUE_APP_SENTRY_DSN || "",
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
    }),
    new Sentry.Replay(),
  ],
  enabled: process.env.VUE_APP_SENTRY_ENABLED === "true",
  environment: process.env.VUE_APP_SENTRY_ENVIRONMENT_NAME
});
new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
  i18n
}).$mount("#app");

Vue.filter("dashable", dashable);
Vue.filter("nullable", nullable);
